<div *ngIf="loadingFlag" class="loading-container">
  <mat-spinner></mat-spinner>
  <h2 class="mat-h2">We're working on it.</h2>
  <p class="mat-body-1">Hang on! This may take a couple of minutes.</p>
  <mat-progress-bar mode="determinate" [value]="progressValue"></mat-progress-bar>
</div>

<div *ngIf="checkoutUrl" class="loading-container">
  <h2 class="mat-h2">
    We opened a new tab for checkout.
    <br />
    If you can't see it,
    <button button mat-button color="primary" (click)="checkoutOnClick()">click here</button>
  </h2>
  <mat-spinner></mat-spinner>
  <p class="mat-body-1"></p>
</div>

<div *ngIf="!loadingFlag && !checkoutUrl" class="subscribe-page-container">
  <mat-card class="subscribe-card">
    <mat-card-content class="subscribe-card-content">
      <div class="subscribe-section">
        <div class="spinner-container" *ngIf="productData === undefined">
          <mat-spinner></mat-spinner>
        </div>
        <app-product-price
          *ngIf="productData"
          [product]="productData"
          (subscribeEmitter)="subscribeOnClick($event)"
          (onPromoCodeEmitter)="promoOnClick()"
        >
        </app-product-price>
        <div *ngIf="productData === null">
          Sorry, we were unable to find the product data.<br /><br />
          Please let us know about this with the green feedback button on the bottom right.
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
